<template>
  <div>
    <v-menu 
      offset-y 
      open-on-hover
      v-if="isUser"
      close-on-content-click
      content-class="qmkey-toolbar-menu-contents elevation-1"
      dense
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn 
          v-bind="attrs"
          v-on="on"
          icon
          small
        >
          <v-avatar
            size="36px"
          >
            <img
              :src="user_avatar"
              class="username-picture"
            />
          </v-avatar>
        </v-btn>
      </template>
      <v-list dense>
        <v-subheader>{{ $vuetify.lang.translator('user') }} {{ user.first_name }} {{ user.last_name }}</v-subheader>
        <!-- <v-list-item>
             <v-list-item-title>
             Usuario {{ user.first_name }} {{ user.last_name }}
             </v-list-item-title>
             </v-list-item> -->
        <v-list-item to="todoList">
          <v-list-item-title>TodoList</v-list-item-title>
        </v-list-item>
        <v-list-item to="preferences">
          <v-list-item-title>
            {{ $vuetify.lang.translator('user_menu.process_map_image') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item 
          @click="dialogChangePassword=true"
          v-if="show_password_change"
        >
          <v-list-item-title>
            {{ $vuetify.lang.translator('user_menu.change_password') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item :to="logout_target">
          <v-list-item-content>
            <v-list-item-title>
              {{ $vuetify.lang.translator('logout') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <ChangePasswordForm
      :dialogChangePassword.sync="dialogChangePassword"
      @close-dialog="dialogChangePassword=$event"
    />
  </div>
</template>

<script>
 import { mapGetters } from 'vuex'
 import ChangePasswordForm from '@/components/ChangePasswordForm'
 import { resolve_logo } from '@/utils/logos';

 export default {
   name: 'UserMenu',

   components: {
     ChangePasswordForm,
   },

   data: () => ({
     dialogChangePassword: false,
   }),

   computed: {
     ...mapGetters(['isUser', 'isManager', 'isAdmin', 'sitePath', 'user', 'site_data']),

     user_avatar() {
       return this.user.photo_url ||  "/usuario.png";
     },

     show_password_change() {
       return !!this.site_data.allow_password_change;
     },

     logout_target() {
       return (this.$sso && this.$sso.enabled && this.$sso.logoutURL) ? 'ssologout' : 'logout';
     },
   },

   methods: {
   },
 };

</script>
